/* Collection confirmation. Fixed, bounded option matching; no navigation hooks. */
(function () {
  'use strict';
  var pickupValues = ['collection', 'collect from store', 'click & collect', 'click and collect', 'click & collection', 'collection only', 'collect only', 'click & collect only', 'click and collect only', 'pickup', 'pick up', 'store pickup', 'local pickup', 'in-store pickup', 'in store pickup'];
  var variants = Object.create(null);
  var permits = new WeakMap();
  var pending = null;
  var dialog = document.getElementById('serlex-collection-confirm');
  if (!dialog) return;
  var config = JSON.parse(document.getElementById('serlex-storefront-config').textContent);
  var box = dialog.querySelector('[role="dialog"]');
  var lastFocus;
  var previousOverflow;
  var pausedModal;

  function normalize(value) { return String(value || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  function isPickup(value) { return pickupValues.indexOf(normalize(value)) !== -1; }
  function isDelivery(value) { return /\bdelivery\b/.test(normalize(value)); }
  function pickupIndex(variant) { return (variant.options || []).findIndex(isPickup); }
  function isCollection(product, variant) { return product.collectionOnly || pickupIndex(variant) !== -1; }
  function deliveryMatches(product, selected) {
    var index = pickupIndex(selected);
    if (index < 0 || product.collectionOnly) return [];
    return product.variants.filter(function (variant) {
      return isDelivery(variant.options[index]) && variant.options.length === selected.options.length &&
        variant.options.every(function (value, i) { return i === index || value === selected.options[i]; });
    });
  }
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      var temp = document.createElement('span');
      temp.innerHTML = window.Shopify.formatMoney(cents, config.moneyFormat);
      return temp.textContent;
    }
    return (Number(cents) / 100).toFixed(2);
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  }
  function register(product, form) {
    product.collectionOnly = product.collectionOnly || (product.tags || []).indexOf('serlex-collection-only') !== -1;
    (product.variants || []).forEach(function (variant) { variants[String(variant.id)] = {product: product, variant: variant}; });
    if (form) {
      var note = form.querySelector('[data-serlex-fulfilment-note]');
      if (!note && product.variants.some(function (v) { return isCollection(product, v); })) {
        note = node('div', 'serlex-fulfilment-note');
        note.setAttribute('data-serlex-fulfilment-note', '');
        note.setAttribute('aria-live', 'polite');
        var quantity = form.querySelector('.quantity-product');
        form.insertBefore(note, quantity || form.firstChild);
      }
      updateNote(form);
    }
  }
  function scan() {
    document.querySelectorAll('[data-serlex-fulfilment]:not([data-serlex-loaded])').forEach(function (el) {
      try { register(JSON.parse(el.textContent)); el.setAttribute('data-serlex-loaded', ''); }
      catch (error) { /* Malformed data never creates a guessed delivery variant. */ }
    });
  }
  function selectedEntry(form) {
    var field = form.querySelector('[name="id"]');
    return field && variants[String(field.value)];
  }
  function updateNote(form) {
    var note = form.querySelector('[data-serlex-fulfilment-note]');
    if (!note) return;
    var entry = selectedEntry(form);
    note.textContent = '';
    note.hidden = !entry;
    if (!entry) return;
    var collection = isCollection(entry.product, entry.variant);
    note.classList.toggle('serlex-fulfilment-note--delivery', !collection);
    note.appendChild(node('strong', '', collection ? 'Collection from Swords selected' : 'Delivery selected'));
    note.appendChild(node('p', '', collection ? 'Planning to have this item delivered? Choose a delivery option instead. We will ask you to confirm collection before adding it.' : 'Check the selected option and price before adding this item. Final delivery details are shown at checkout.'));
    if (collection && deliveryMatches(entry.product, entry.variant).some(function (v) { return v.available; })) {
      var button = node('button', 'serlex-text-button', 'Compare delivery options');
      button.type = 'button';
      button.addEventListener('click', function () { open(form, null, [entry], false); });
      note.appendChild(button);
    }
  }
  function entriesFor(form) {
    scan();
    if (form.getAttribute('id') === 'bundledAddToCart') {
      var entries = [];
      form.querySelectorAll('.bundled-item').forEach(function (item) {
        var checkbox = item.querySelector('.bundled-checkbox');
        var field = item.querySelector('.product-qty .field');
        var entry = field && variants[String(field.id)];
        if (entry && (!checkbox || checkbox.checked) && isCollection(entry.product, entry.variant)) entries.push(entry);
      });
      return entries;
    }
    var entry = selectedEntry(form);
    return entry && isCollection(entry.product, entry.variant) ? [entry] : [];
  }
  function close() {
    dialog.hidden = true;
    document.body.style.overflow = previousOverflow;
    pending = null;
    if (pausedModal) {
      if (typeof pausedModal._enforceFocus === 'function') pausedModal._enforceFocus();
      else if (typeof pausedModal.enforceFocus === 'function') pausedModal.enforceFocus();
      pausedModal = null;
    }
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function switchVariant(form, product, variant) {
    var selectors = form.querySelectorAll('.single-option-selector');
    if (selectors.length === variant.options.length) {
      selectors.forEach(function (selector, index) {
        if (selector.value !== variant.options[index]) {
          selector.value = variant.options[index];
          if (window.jQuery) window.jQuery(selector).trigger('change');
          else selector.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
    }
    var master = form.querySelector('[name="id"]');
    if (!master) return false;
    master.value = String(variant.id);
    master.dispatchEvent(new Event('change', {bubbles: true}));
    updateNote(form);
    return String(master.value) === String(variant.id);
  }
  function open(form, trigger, entries, adding) {
    if (pending) return;
    lastFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    pending = {form: form, trigger: trigger, entries: entries, adding: adding};
    // Bootstrap 4 also traps native focus through jQuery's focusin polyfill.
    // Pause that trap while this dialog is above quick view, and restore it on close.
    if (window.jQuery) {
      pausedModal = window.jQuery('.modal.show, .modal.in').last().data('bs.modal');
      window.jQuery(document).off('focusin.bs.modal');
    }
    var items = dialog.querySelector('[data-serlex-confirm-items]');
    var choices = dialog.querySelector('[data-serlex-delivery-options]');
    items.textContent = '';
    choices.textContent = '';
    entries.forEach(function (entry) {
      var item = node('div', 'serlex-confirm__item');
      item.appendChild(node('strong', '', entry.product.title));
      item.appendChild(node('p', '', (entry.variant.title === 'Default Title' ? 'Collection' : entry.variant.title) + ' · ' + money(entry.variant.price) + ' each'));
      items.appendChild(item);
    });
    var entry = entries[0];
    var matches = entries.length === 1 && form.getAttribute('id') !== 'bundledAddToCart' ? deliveryMatches(entry.product, entry.variant) : [];
    var available = matches.filter(function (variant) { return variant.available; });
    if (available.length) {
      choices.appendChild(node('p', '', 'Want delivery instead? Your other options stay the same.'));
      available.forEach(function (variant) {
        var button = node('button', 'serlex-button serlex-button--delivery', 'Choose ' + variant.options[pickupIndex(entry.variant)] + ' · ' + money(variant.price));
        button.type = 'button';
        button.addEventListener('click', function () {
          if (switchVariant(form, entry.product, variant)) {
            close();
            var note = form.querySelector('[data-serlex-fulfilment-note]');
            if (note) { note.setAttribute('tabindex', '-1'); note.focus(); }
          }
        });
        choices.appendChild(button);
      });
    } else {
      choices.appendChild(node('p', '', matches.length ? 'The matching delivery option is currently sold out. Contact us if you need delivery.' : 'A matching delivery option is not available here. Contact us before ordering if you need delivery.'));
      var contact = node('a', 'serlex-text-button', 'Ask about delivery');
      contact.href = config.contactUrl;
      choices.appendChild(contact);
    }
    dialog.querySelector('[data-serlex-confirm]').textContent = adding ? 'Yes, collect — add to basket' : 'Keep collection selected';
    dialog.hidden = false;
    document.body.style.overflow = 'hidden';
    box.focus();
  }
  function guard(event, form, trigger) {
    if (!form || permits.has(form)) return;
    var entries = entriesFor(form);
    if (!entries.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(form, trigger, entries, true);
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.add-to-cart, .bt-add-to-cart');
    if (!trigger || trigger.disabled || trigger.classList.contains('disabled')) return;
    guard(event, trigger.closest('form'), trigger);
  }, true);
  document.addEventListener('submit', function (event) {
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(event.target.action)) guard(event, event.target, event.submitter || null);
  }, true);
  dialog.querySelector('[data-serlex-confirm]').addEventListener('click', function () {
    if (!pending) return;
    var action = pending;
    // Re-check the variant if another script changed the form while the dialog was open.
    var now = entriesFor(action.form);
    var same = now.length === action.entries.length && now.every(function (entry, i) { return entry.variant.id === action.entries[i].variant.id; });
    close();
    if (!same || !action.adding) return;
    permits.set(action.form, true);
    try {
      if (action.trigger) action.trigger.click();
      else if (action.form.requestSubmit) action.form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(action.form);
    } finally { window.setTimeout(function () { permits.delete(action.form); }, 0); }
  });
  dialog.querySelectorAll('[data-serlex-cancel]').forEach(function (button) { button.addEventListener('click', close); });
  document.addEventListener('keydown', function (event) {
    if (!pending) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); }
    if (event.key === 'Tab') {
      var focusable = Array.prototype.filter.call(box.querySelectorAll('button, a[href], [tabindex="0"]'), function (el) { return !el.disabled && el.offsetParent !== null; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === box)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === box)) { event.preventDefault(); first.focus(); }
    }
  }, true);
  document.addEventListener('focusin', function (event) {
    // Keep legacy Bootstrap quick-view's focus trap from stealing focus from this dialog.
    if (pending && dialog.contains(event.target)) event.stopImmediatePropagation();
    else if (pending) box.focus();
  }, true);
  function refresh(form) { window.setTimeout(function () { scan(); if (form) updateNote(form); }, 0); }
  document.addEventListener('change', function (event) { refresh(event.target.closest('form')); });
  if (window.jQuery) window.jQuery(document).on('change.serlexFulfilment', 'form select, form :radio', function () { refresh(this.closest('form')); });
  function initialize() {
    scan();
    document.querySelectorAll('[data-serlex-fulfilment-note]').forEach(function (note) { var form = note.closest('form'); if (form) updateNote(form); });
  }
  document.addEventListener('shopify:section:load', initialize);
  window.SerlexFulfilment = {register: register};
  initialize();
  window.addEventListener('load', initialize);
})();
